import React, { useEffect, useState } from 'react';
import type { JSX } from 'react';
import { navBarHeight } from '../../Constants';
import DocumentTreeNodeViewComponent from '../../Components/Documents/DocumentTreeNodeViewComponent';
import { useTitle } from 'shouldve-been-react';

type DocumentsTabProps = {
    treeNodeId: number,
};

function DocumentsTab(props: Readonly<DocumentsTabProps>): JSX.Element {

    useTitle('K-Fleet Experience - Documents');

    const [windowSize, setWindowSize] = useState<[number, number]>([1920, 1080]);
    
    useEffect(() => {

        function updateSize(): void {
            setWindowSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div style={{
            padding: '5px',
            height: windowSize[1] - navBarHeight,
            overflow: 'auto',
        }}>
            <DocumentTreeNodeViewComponent
                treeNodeId={props.treeNodeId}
            />
        </div>
    );
}

export default DocumentsTab;